import ptLang from "./entries/pt_PT";

const AppLocale = {
  pt: ptLang,
};

export default AppLocale;
